@if (showHeaderAndFooter()) {
  <app-header></app-header>
}

<div class="flex-fill ids-mb-5">
  <router-outlet />
</div>

<toast-messages></toast-messages>

@if (showHeaderAndFooter()) {
  <app-footer></app-footer>
}
